(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        if (!this.disclosure || !this.toggle) return;
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipa-cenova-lista"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tclInit) return;
  window.__tclInit = true;
  var editor = function () { return !!(window.Shopify && Shopify.designMode); };

  /* Carousel se záložkami: první za lištou, jinak první na stránce (hledá se pokaždé znovu –
     v editoru se sekce carouselu při každé změně nastavení vymění za nový element). */
  function carouselFor(bar) {
    var all = document.querySelectorAll('.tpc.tpc--tabs');
    for (var i = 0; i < all.length; i++) {
      if (bar.compareDocumentPosition(all[i]) & Node.DOCUMENT_POSITION_FOLLOWING) return all[i];
    }
    return all[0] || null;
  }
  function tabOf(box, n) {
    return box ? box.querySelector('.tpc__tab[data-tpc-tab="' + n + '"]') : null;
  }
  /* Výška lepicí hlavičky, aby carousel nezajel pod ni. */
  function headerOffset() {
    var h = document.querySelector('[data-is-sticky="true"]');
    var r = h ? h.getBoundingClientRect() : null;
    return (r && r.bottom > 0 ? r.bottom : 0) + 16;
  }

  /* Stav lišty se vždy odvodí ze stavu carouselu: zvýrazněné je tlačítko otevřené záložky
     (u dvou tlačítek na tutéž záložku to naposled kliknuté), tlačítka na neexistující nebo
     schovanou (prázdnou) záložku bez odkazu zmizí, a když nezbude žádné, zmizí celá lišta. */
  function sync(bar) {
    /* jen tlačítka záložek; filtr ceny zvýraznění drží sám (markPrice) */
    if (!bar.querySelector('.tcl__btn:not([data-tcl-price])')) { syncPrice(bar); return; }
    var box = carouselFor(bar);
    var act = box && box.querySelector('.tpc__tab.is-active');
    var actN = act ? act.getAttribute('data-tpc-tab') : null;
    var on = null;
    bar.querySelectorAll('.tcl__btn:not([data-tcl-price])').forEach(function (b) {
      var n = b.getAttribute('data-tcl-tab');
      if (n !== '0' && !editor() && b.tagName !== 'A') {
        var t = tabOf(box, n);
        b.parentNode.hidden = !t || t.hidden;
      }
      if (actN && n === actN && !b.parentNode.hidden && (!on || b === bar._tclLast)) on = b;
    });
    var changed = false;
    bar.querySelectorAll('.tcl__btn:not([data-tcl-price])').forEach(function (b) {
      var is = b === on;
      if (b.classList.contains('is-active') !== is) changed = true;
      b.classList.toggle('is-active', is);
      if (b.getAttribute('data-tcl-tab') !== '0') b.setAttribute('aria-pressed', is ? 'true' : 'false');
    });
    if (bar.querySelector('.tcl__btn[data-tcl-price]')) syncPrice(bar);   /* smíšená lišta */
    else if (!editor()) bar.hidden = !bar.querySelector('.tcl__item:not([hidden])');
    if (on && changed) {
      /* zvýrazněné tlačítko do pohledu jen uvnitř lišty (posun stránky ne) */
      var list = on.closest('.tcl__list');
      var l = on.offsetLeft - list.offsetLeft, r = l + on.offsetWidth;
      if (l < list.scrollLeft) list.scrollLeft = l - 12;
      else if (r > list.scrollLeft + list.clientWidth) list.scrollLeft = r - list.clientWidth + 12;
    }
  }
  /* Filtr ceny: carousel s volbou „Filtrovat podle prvků stránky“ (kdekoli na stránce). */
  function filterable() { return document.querySelector('.tpc[data-tpc-filterable]'); }
  function syncPrice(bar) {
    if (editor()) return;
    var has = !!filterable();
    bar.querySelectorAll('.tcl__btn[data-tcl-price]').forEach(function (b) {
      if (b.tagName !== 'A') b.parentNode.hidden = !has;   /* bez carouselu a bez odkazu nemá co dělat */
    });
    bar.hidden = !bar.querySelector('.tcl__item:not([hidden])');
  }
  function markPrice(bar, btn) {
    bar.querySelectorAll('.tcl__btn[data-tcl-price]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  /* Text ceny do nadpisu carouselu (30. 10. 2026): vlastní text tlačítka, jinak se složí
     z rozsahu – „do 500 Kč“, „nad 5 000 Kč“, „od 500 do 1 000 Kč“. Složený text je česky
     a v Kč, proto jen na české doméně v Kč; v mutacích bez vlastního textu nic. */
  function priceLabel(btn) {
    var own = btn.getAttribute('data-tcl-label');
    if (own) return own;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var loc = (window.Shopify && Shopify.locale) || '';
    if (cur !== 'CZK' || loc.slice(0, 2) !== 'cs') return '';
    var lo = parseFloat(btn.getAttribute('data-tcl-min')), hi = parseFloat(btn.getAttribute('data-tcl-max'));
    var f = function (n) { return Math.round(n).toLocaleString('cs-CZ').replace(/\s/g, ' ') + ' Kč'; };
    if (!(lo > 0) && hi > 0) return 'do ' + f(hi);
    if (lo > 0 && !(hi > 0)) return 'nad ' + f(lo);
    if (lo > 0 && hi > 0) return 'od ' + f(lo) + ' do ' + f(hi);
    return '';
  }
  /* Kč → měna domény (kurz obchodu), dolní mez 0,01, aby nepřišly produkty s nulovou cenou. */
  function priceFilter(btn) {
    var lo = parseFloat(btn.getAttribute('data-tcl-min')), hi = parseFloat(btn.getAttribute('data-tcl-max'));
    if (isNaN(lo) && isNaN(hi)) return null;
    var cur = (window.Shopify && Shopify.currency) || {}, rate = parseFloat(cur.rate) || 1;
    var a = isNaN(lo) ? 0.01 : Math.max(0.01, lo * rate), b = isNaN(hi) ? 99999999 : hi * rate;
    return { q: 'pf_p_cena=' + encodeURIComponent(a.toFixed(2) + ':' + b.toFixed(2)) };
  }
  /* Po výběru ceny (30. 10. 2026, klient): posunout k dlaždicím „Pro koho“ mezi lištou
     a výsledky, ať jde rozpočet rovnou zúžit; bez nich k výsledkům, a to jen tehdy, když
     nejsou vidět. Dlaždice až za výsledky se nepoužijí (posun by výsledky přeskočil). */
  function tilesBetween(bar, box) {
    var all = document.querySelectorAll('[data-tkd-filter-mode]');
    for (var i = 0; i < all.length; i++) {
      var t = all[i];
      if (!(bar.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      if (!(t.compareDocumentPosition(box) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      if (!t.getClientRects().length) continue;            /* skrytá (display: none) */
      return t;
    }
    return null;
  }
  function revealAfterPrice(bar, box) {
    var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var tiles = tilesBetween(bar, box);
    var r = (tiles || box).getBoundingClientRect();
    if (tiles) {
      if (Math.abs(r.top - headerOffset()) < 8) return;
    } else if (r.top > 0 && r.top < window.innerHeight * 0.7) return;
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - headerOffset()), behavior: smooth ? 'smooth' : 'auto' });
    if (!tiles) return;
    /* Hlavička při posunu dolů schová řádek menu (is-out) a nahoru ho zase ukáže, takže
       výška změřená předem nesedí. Hlavička mění stav s prodlevou (animace 300 ms, pak
       teprve vyhodnotí směr posunu), proto se poloha po doběhnutí posunu kontroluje
       opakovaně (4× po 350 ms) a dorovná se pokaždé, když se rozejde o 8 px a víc.
       Když mezitím posouvá uživatel, nic se nedorovnává. */
    var checks = 0, token = {};
    bar._tclReveal = token;
    var fix = function () {
      if (bar._tclReveal !== token) return;
      var d = tiles.getBoundingClientRect().top - headerOffset();
      if (Math.abs(d) >= 8) window.scrollTo({ top: Math.max(0, window.pageYOffset + d), behavior: 'auto' });
      if (++checks < 4) setTimeout(fix, 350);
    };
    var settle = function () { setTimeout(fix, 350); };
    var done = false, once = function () { if (done) return; done = true; window.removeEventListener('scrollend', once); settle(); };
    if ('onscrollend' in window && smooth) {
      window.addEventListener('scrollend', once);
      setTimeout(once, 1500);                                /* pojistka, kdyby scrollend nepřišel */
    } else setTimeout(once, smooth ? 800 : 0);
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (bar._tclReveal === token) bar._tclReveal = null; }, { once: true, passive: true });
    });
  }

  /* Sledovat záložky carouselu (třída is-active, atribut hidden); při výměně carouselu znovu navázat. */
  function bind(bar) {
    var box = carouselFor(bar);
    if (box !== bar._tclBox) {
      if (bar._tclObs) bar._tclObs.disconnect();
      bar._tclObs = null;
      bar._tclBox = box;
      if (box) {
        bar._tclObs = new MutationObserver(function () { sync(bar); });
        bar._tclObs.observe(box, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      }
    }
    sync(bar);
  }
  function bindAll() { document.querySelectorAll('[data-tcl]').forEach(bind); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tcl .tcl__btn');
    if (!btn) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var bar = btn.closest('[data-tcl]');
    if (btn.hasAttribute('data-tcl-price')) {
      var fbox = filterable();
      if (!fbox) return;                     /* bez carouselu: odkaz (je-li) proběhne normálně */
      e.preventDefault();
      markPrice(bar, btn);
      var pf = priceFilter(btn);
      document.dispatchEvent(new CustomEvent('tipa:filtr', { detail: { group: 'cena', filter: pf, label: pf ? priceLabel(btn) : '' } }));
      revealAfterPrice(bar, fbox);
      return;
    }
    var box = carouselFor(bar);
    var tab = tabOf(box, btn.getAttribute('data-tcl-tab'));
    if (!tab || tab.hidden) return;          /* bez záložky: odkaz (je-li) proběhne normálně */
    e.preventDefault();
    bar._tclLast = btn;
    tab.click();                             /* carousel přepne panel sám (T.activate) */
    sync(bar);
    var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var y = box.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    /* posun stránky zruší vysunutí záložky v liště carouselu (scrollIntoView v T.activate) →
       vysunout ji posunem samotné lišty; scrollIntoView by zastavil posun stránky */
    setTimeout(function () {
      var tb = tab.closest('.tpc__tabs');
      if (!tb) return;
      var l = tab.offsetLeft - tb.offsetLeft, r = l + tab.offsetWidth;
      if (l < tb.scrollLeft) tb.scrollLeft = l - 12;
      else if (r > tb.scrollLeft + tb.clientWidth) tb.scrollLeft = r - tb.clientWidth + 12;
    }, 50);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  else bindAll();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(bindAll, 0); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipa-kategorie-dlazdice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.tkdInit) return;
      wrap.dataset.tkdInit = '1';
      var track = wrap.querySelector('[data-tkd-track]');
      var prev = wrap.querySelector('[data-tkd-prev]');
      var next = wrap.querySelector('[data-tkd-next]');
      if (!track || !prev || !next) return;   /* šipky vypnuté v Nastavení motivu → posun touchpadem/prstem */

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max - 2;
      }
      /* posun o celé viditelné sloupce (o šířku pásu), scroll-snap dorovná na dlaždici */
      function go(dir) {
        track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-tkd]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    /* Filtr stránky (Dárkový booster, 26. 10. 2026): dlaždice nikam nevede, pošle carouselu
       s volbou „Filtrovat podle prvků stránky“ svou kolekci (událost tipa:filtr, skupina 'pro').
       Druhý klik výběr zruší. Bez takového carouselu na stránce zůstane obyčejný odkaz;
       Cmd/Ctrl+klik otevře kategorii v nové kartě. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-tkd-filter-mode] .tkd__card[data-tkd-f]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var box = document.querySelector('.tpc[data-tpc-filterable]');
      if (!box) return;
      e.preventDefault();
      var on = !a.classList.contains('is-active');
      document.querySelectorAll('[data-tkd-filter-mode] .tkd__card[data-tkd-f]').forEach(function (c) {
        var is = on && c === a;
        c.classList.toggle('is-active', is);
        c.setAttribute('aria-pressed', is ? 'true' : 'false');
      });
      var f = null;
      if (on) { try { f = JSON.parse(a.getAttribute('data-tkd-f')); } catch (err) { f = null; } }
      /* label = tvar do nadpisu carouselu (30. 10. 2026), např. „chlapa“ */
      var lab = on ? (a.getAttribute('data-tkd-label') || '') : '';
      document.dispatchEvent(new CustomEvent('tipa:filtr', { detail: { group: 'pro', filter: f, label: lab } }));
      /* k výsledkům jen tehdy, když nejsou vidět */
      var r = box.getBoundingClientRect();
      if (r.top > 0 && r.top < window.innerHeight * 0.7) return;
      var h = document.querySelector('[data-is-sticky="true"]'), hr = h ? h.getBoundingClientRect() : null;
      var off = (hr && hr.bottom > 0 ? hr.bottom : 0) + 16;
      var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - off), behavior: smooth ? 'smooth' : 'auto' });
    });
    /* editor motivu: sekce se po změně nastavení vykreslí znovu */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
